import { formatTimeAgo } from "@nova/format"
import { useTick } from "./ticker"

export const useTimeAgo = ({ timestamp }: { timestamp: number | undefined }) => {
    useTick(1000)
    return timestamp === undefined ? "" : formatTimeAgo(timestamp, Date.now())
}
